import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Customer } from '../../../shared/models/customer';

import { CustomerService } from '../../../shared/services/customer.service';
import { faSpinner } from '../../../icons';
@Component({
    selector: 'app-customer-login',
    templateUrl: './customer-login.component.html',
    styleUrls: ['./customer-login.component.scss'],
    standalone: false
})
export class CustomerLoginComponent implements OnInit {
	  faSpinner = faSpinner;
	customer: Customer;
	sending: boolean;

  constructor(private customerServ: CustomerService,
  	private router: Router,
  	private route: ActivatedRoute) { }

  ngOnInit(): void {
  	this.customer = <Customer> {
  		name: '',
  		surname: '',
  		phone: ''
  	};
  }

  checkNameFormat(obj, field) {
    // Match characters, accented or not
    let regex = /\p{Letter}+$/u;

  	setTimeout(() => {
	    for(let i = 0; i < obj[field].length; i++) {
	    	let ch = obj[field].charAt(i);
	    	if(regex.test(ch)) {
	    		// valid input
	    	} else {
	    		let letters = obj[field].split('');
	    		letters.splice(i, 1);
	    		obj[field] = letters.join('');
	    		i--;
	    	}
	    }
  	}, 50);
  }

  send() {
  	this.sending = true;
  	this.customerServ.setCustomer(this.customer);
  	setTimeout(() => {
	  	this.customerServ.getToken().subscribe(
	  		res => {
	  			this.sending = false;
	  			if(res == null) {
	  				alert("Não encontramos seus dados. Por favor, preencha novamente");
	  				this.router.navigate(['../dados-cliente'], {relativeTo: this.route});
	  				return;
	  			}
	  			alert(`Bem-vindo ${res.name}!`);
	  			this.router.navigate(['../meus-pedidos'], {relativeTo: this.route});
	  		},
	  		err => {
	  			this.sending = false;
	  			console.log(err);
	  			alert("Não encontramos seus dados. Por favor, preencha novamente");
	  			this.router.navigate(['../dados-cliente'], {relativeTo: this.route});
	  		}
	  	);
  	}, 200);
  }

}
